import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "navMain",
    "navSecondary",
    "navWrapper",
    "navListWrapper",
    "navToggler",
    "navTogglerIcon",
    "navTitleBar",
    "dropdown",
    "searchForm",
    "notification",
    "accordionHead",
  ];

  connect() {
    this.BREAKPOINT = 991;
    this.hasBackdrop = false;
    this.handleDocumentClick = this.handleDocumentClick.bind(this);

    // Initialize navigation based on viewport size
    this.updateNavigationMode();
    window.addEventListener("resize", this.debounce(this.updateNavigationMode.bind(this), 250));
    document.addEventListener("click", this.handleDocumentClick);

    this.initGeneralHandlers();
  }

  disconnect() {
    window.removeEventListener("resize", this.updateNavigationMode);
    document.removeEventListener("click", this.handleDocumentClick);
    this.hideBackdrop();
  }

  showBackdrop() {
    if (!this.hasBackdrop) {
      const backdrop = document.createElement('div');
      backdrop.classList.add('modal-backdrop', 'fade', 'show');
      backdrop.addEventListener('click', () => this.closeAllDropdowns());
      document.body.appendChild(backdrop);
      this.hasBackdrop = true;
    }
  }

  hideBackdrop() {
    const backdrop = document.querySelector('.modal-backdrop');
    if (backdrop) {
      console.log("Backdrop removed");
      backdrop.remove();
      this.hasBackdrop = false;
    }
  }

  toggleNav() {
    document.documentElement.classList.toggle("no-scroll");
    this.navTogglerIconTarget.classList.toggle("active");
    this.navTitleBarTarget.querySelectorAll("div").forEach((div) => div.classList.remove("show"));
  }

  updateNavigationMode() {
    const width = window.innerWidth;
    if (width > this.BREAKPOINT) {
      this.initDesktopNav();
      document.body.classList.add("desktop-nav");
      document.body.classList.remove("mobile-nav");
    } else {
      this.initMobileNav();
      document.body.classList.add("mobile-nav");
      document.body.classList.remove("desktop-nav");
    }
    this.initSearchHandlers();
  }

  initSearchHandlers() {
    const search = document.getElementById("search");
    search.addEventListener("focus", (e) => {
        e.preventDefault();
        this.openSearch(search);
      });

      search.addEventListener("blur", (e) => {
        e.preventDefault();
        this.closeSearch(search);
      });

      search.addEventListener("keydown", (e) => {
        if (e.key === "Enter" || e.key === " ") {
          this.openSearch(search);
        }
      });
  }

  initDesktopNav() {
    this.setupDesktopNavPosition();
  }


  setupDesktopNavPosition() {
    const navElement = document.querySelector('.no-style.nav-secondary');
    if (navElement) {
        navElement.style.top = "0px";
    }
  }

  initMobileNav() {
          this.setupMobileNavPosition();
          this.setupNavToggler();
          this.setupDropdownTriggers();
          this.setupBackButton();
  }

  setupMobileNavPosition() {
          const navElement = document.querySelector('.no-style.nav-secondary');
          if (navElement) {
              navElement.style.top = "460px";
          }
  }

  setupNavToggler() {
          this.navTogglerTarget.addEventListener("click", e => {
                  e.preventDefault();
                  this.toggleNav();
          });

          this.navTogglerTarget.addEventListener("click", e => {
                  if (!this.navWrapperTarget.classList.contains("l2")) {
                          this.navWrapperTarget.classList.toggle("show");
          }
     });
  }

  setupDropdownTriggers() {
      const dropdownTriggers = this.navMainTarget.querySelectorAll(".has-dropdown > span, .has-dropdown > a");
         dropdownTriggers.forEach((trigger) => {
            trigger.addEventListener("click", (e) => {
                    e.preventDefault();
                    this.handleDropdownClick(e);
            });
         });
  }

  handleDropdownClick(e) {
    if (!this.navWrapperTarget.classList.contains("l2")) {
        const target = e.target;
        const isDirectLink = target.classList.contains('nav-list-link') && target.parentElement.classList.contains('has-dropdown');

        if (target.classList.contains('has-dropdown') || isDirectLink) {
            this.openSubmenu(target);
        }
     }
  }

  openSubmenu(target) {
      const categoryText = target.textContent;
      target.parentElement.classList.toggle("show");
      this.navWrapperTarget.classList.toggle("l2");
      this.navListWrapperTarget.classList.toggle("l2")

      this.updateTitleBar(categoryText);
  }

  updateTitleBar(categoryText) {
      const titleBar = this.navTitleBarTarget;
      titleBar.querySelector('div').classList.toggle("show");
      titleBar.querySelector('.nav-title').classList.toggle("show");
      titleBar.querySelector('.nav-title').textContent = categoryText;
  }

  setupBackButton() {
      this.navTitleBarTarget.querySelector(".nav-back-link a").addEventListener("click", (e) => {
      e.preventDefault();
      this.resetMobileNav();

      });
  }


// initMobileNav() {
//   const navElement = document.querySelector('.no-style.nav-secondary');
//   if (navElement) {
//       navElement.style.top = "460px";
//   }
//
//   this.navTogglerTarget.addEventListener("click", (e) => {
//     e.preventDefault();
//     this.toggleNav();
//   });
//
//   this.navTogglerTarget.addEventListener("click", (e) => {
//     if (!this.navWrapperTarget.classList.contains("l2")) {
//       this.navWrapperTarget.classList.toggle("show");
//     }
//   });
//
//   const dropdownTriggers = this.navMainTarget.querySelectorAll(".has-dropdown > span, .has-dropdown > a");
//   dropdownTriggers.forEach((trigger) => {
//
//     trigger.addEventListener("click", (e) => {
//       e.preventDefault();
//       if (!this.navWrapperTarget.classList.contains("l2")) {
//         const target = e.target;
//         const isDirectLink = target.classList.contains('nav-list-link') && target.parentElement.classList.contains('has-dropdown');
//         if (target.classList.contains('has-dropdown') || isDirectLink) {
//           const categoryText = target.textContent;
//           target.parentElement.classList.toggle("show");
//           this.navWrapperTarget.classList.toggle("l2");
//           this.navListWrapperTarget.classList.toggle("l2");
//
//           const titleBar = this.navTitleBarTarget;
//           titleBar.querySelector('div').classList.toggle("show");
//           titleBar.querySelector('.nav-title').classList.toggle("show");
//           titleBar.querySelector('.nav-title').textContent = categoryText;
//         }
//       }
//     });
//   });
//
//   this.navTitleBarTarget.querySelector(".nav-back-link a").addEventListener("click", (e) => {
//     e.preventDefault();
//     this.resetMobileNav();
//   });
// }

  toggleDropdown(trigger) {
    const parent = trigger.parentElement;
    const isActive = this.navMainTarget.classList.contains("active");

    this.dropdownTargets.forEach((dropdown) => dropdown.classList.remove("touch-active"));

    if (isActive && parent.classList.contains("was-active")) {
      this.navMainTarget.classList.remove("active");
      parent.classList.remove("was-active");
      this.hideBackdrop();
    } else {
      this.navMainTarget.classList.add("active");
      parent.classList.add("touch-active", "was-active");
      this.showBackdrop();
    }
  }

  openSearch(search) {
    this.navMainTarget.classList.add("active");
    search.focus();
    this.showBackdrop();
  }

  closeSearch(search) {
    this.navMainTarget.classList.remove("active");
    this.hideBackdrop();
  }

  resetMobileNav() {
    this.dropdownTargets.forEach((dropdown) => dropdown.classList.remove("show"));
    this.navWrapperTarget.classList.remove("l2");
    this.navListWrapperTarget.classList.remove("l2");
    this.navTitleBarTarget.querySelector(".nav-title").textContent = "";
    this.navTitleBarTarget.querySelectorAll("div").forEach((div) => div.classList.remove("show"));
  }

  initGeneralHandlers() {
    this.notificationTargets.forEach((notification) => {
      notification.addEventListener("click", () => notification.classList.remove("is-visible"));
    });

    this.accordionHeadTargets.forEach((accordionHead) => {
      accordionHead.addEventListener("click", () => {
        accordionHead.parentElement.classList.toggle("is-active");
      });
    });

    document.addEventListener("keyup", (e) => {
      if (e.key === "Escape") {
        document.documentElement.classList.remove("no-scroll");
        this.navMainTarget.classList.remove("active");
        this.searchFormTarget.blur();
      }
    });
  }

  debounce(func, wait) {
    let timeout;
    return function (...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), wait);
    };
  }

  closeAllDropdowns() {
    this.navMainTarget.classList.remove("active");
    this.dropdownTargets.forEach(dropdown => {
      dropdown.classList.remove("touch-active");
      dropdown.classList.remove("was-active");
    });
    this.hideBackdrop();
  }

  handleDocumentClick(event) {
    const isClickInsideNav = this.navMainTarget.contains(event.target);
    const isNavActive = this.navMainTarget.classList.contains("active");

    if (!isClickInsideNav && isNavActive) {
      this.closeAllDropdowns();
    }
  }
}
